import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { isEmpty } from "lodash";
export default {
  methods: {
    validSubmissionExist(submissionHistories) {
      if (isEmpty(submissionHistories)) return false;
      for (var historyId in submissionHistories) {
        const invalidStatuses = ["failed"];
        const historyStatus = submissionHistories[historyId].status;
        if (!_includesInstanceProperty(invalidStatuses).call(invalidStatuses, historyStatus)) return true;
      }
      return false;
    }
  }
};